/*
* 用户账户组件
* zxw
* 创建时间：
* 修改时间：2026-08-12
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import {
    theme,
    message,
    Table,
    Input,
    Select,
    Button,
    Space,
} from 'antd';
import {
    PlusOutlined,
} from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    ShowIPModal,
    GetDropdownActionName,
} from '../../incs/FunHelper.js';

import CNF from '../../incs/Config';

import Entity from './UserEntity';
import AccreditEntity from './UserAccreditEntity';
import UserAuthoritySetEntity from './UserAuthoritySetEntity';

const MODULENAME = CNF.navItems[1].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[1].ptn;
const MODULENAME_URL = CNF.navItems[1].url;

const Lists = (props) => {
    const { btnLists, dataLists, currentIndex, pageCount, changeIndex, setOpen, refresh } = props;

    const {
        token: {
            pageSize,

        },
    } = theme.useToken();

    const update = useCallback((record) => {
        setOpen(true, record);
    }, [setOpen]);

    const [record, setRecord] = useState(null);
    const [accreditOpen, setAccreditOpen] = useState(false);
    const [authorityOpen, setAuthorityOpen] = useState(false);

    const handleAccreditOpen = useCallback((value) => {
        setAccreditOpen(value);
    }, []);

    const handleSetAuthorityOpen = useCallback((value) => {
        setAuthorityOpen(value);
    }, []);

    /**
     * 显示授权弹框
     */
    const showAccreditOpen = useCallback((record) => {
        setRecord(record);
        setAccreditOpen(true);
    }, [])


    /**
     * 显示权限设置弹框
     */
    const showAuthoritySet = useCallback((record) => {
        setRecord(record);
        setAuthorityOpen(true);
    }, [])

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.ACCREDIT:
                showAccreditOpen(record);
                break;
            case '权限' + CNF.actionName.SET:
                showAuthoritySet(record);
                break;
            case CNF.actionName.RESET:
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.username, action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [refresh, update, showAccreditOpen, showAuthoritySet]);

    const hasOpPerm = (
        btnLists.indexOf(MODULENAME_PTN + '_authority_set') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_accredit') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_reset') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_disable') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_active') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
    );

    const columns = useMemo(() => [
        { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
        { title: '用户名', dataIndex: 'username', key: 'username', },
        { title: '电话', dataIndex: 'phone', key: 'phone', },
        { title: '邮箱', dataIndex: 'email', key: 'email', },
        { title: '姓', dataIndex: 'surname', key: 'surname', },
        { title: '名', dataIndex: 'name', key: 'name', },
        { title: '显示名', dataIndex: 'displayname', key: 'displayname', },
        { title: '状态', key: 'status', dataIndex: 'status', width: CNF.tableStatusColumnWidth, },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        {
            title: '', key: 'operation', width: CNF.tableOperationColumnWidth, hidden: !hasOpPerm,
            render: (record) => GetDropdownActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [hasOpPerm, btnLists, operation]);

    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => `共${pageCount}条`,
                    pageSize: pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props?.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
            {accreditOpen && <AccreditEntity
                record={record}
                open={accreditOpen}
                setOpen={handleAccreditOpen}
                refresh={refresh}
            />
            }
            {authorityOpen && <UserAuthoritySetEntity
                record={record}
                open={authorityOpen}
                setOpen={handleSetAuthorityOpen}
            />
            }
        </>
    );
}

const User = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState(CNF.status[0].value);
    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const [username, setUsername] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleStatusChange = useCallback((value) => {
        setStatus(value || '');
        setCurrentIndex(1);
    }, []);

    const handleUsernameChange = useCallback((e) => {
        setUsername(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handlePhoneChange = useCallback((e) => {
        setPhone(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleEmailChange = useCallback((e) => {
        setEmail(e.target.value);
        setCurrentIndex(1);
    }, []);

    const setOpenModal = useCallback((value, record) => {
        setOpen(value);
        setRecord(record || null);
    }, []);

    const create = useCallback(() => {
        setOpenModal(true, null);
    }, [setOpenModal]);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            status,
            username,
            phone,
            email,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, status, username, phone, email]);

    // 按钮权限判断
    const hasCreate = btnLists.includes(MODULENAME_PTN + '_create');

    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Input
                    placeholder='用户名'
                    onChange={handleUsernameChange}
                    value={username}
                />
                <Input
                    placeholder='电话'
                    onChange={handlePhoneChange}
                    value={phone}
                />
                <Input
                    placeholder='邮箱'
                    onChange={handleEmailChange}
                    value={email}
                />
                <Select
                    allowClear
                    placeholder='状态'
                    style={{ width: '100%' }}
                    onChange={handleStatusChange}
                    value={status || undefined}
                    options={CNF.status.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.label
                    }))}
                />
                {hasCreate && (
                    <Button
                        title={CNF.actionName.CREATE + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<PlusOutlined />}
                        onClick={() => {
                            create();
                        }}>
                        {CNF.actionName.CREATE}
                    </Button>
                )}
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                setOpen={setOpenModal}
                refresh={refresh}
                loading={loading}
            />
            <Entity
                preGroup={preGroup}
                btnLists={btnLists}
                open={open}
                record={record}
                setOpen={setOpenModal}
                refresh={refresh}
            />
        </>
    );
}

export default User